import { AtsPurchaseRequestsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { PurchaseRequestDataCollection } from './PurchaseRequestDataCollection'

const PurchaseRequestsPage = () => {
  const { data, loading } = useQuery(AtsPurchaseRequestsPageDocument)
  const canNavigateToJobs = data?.ats._policies.manageJobPostings.can ?? false

  return (
    <ResponsivePage.Body error={null} loading={loading} variant="full">
      <PurchaseRequestDataCollection canNavigateToJobs={canNavigateToJobs} />
    </ResponsivePage.Body>
  )
}

export default PurchaseRequestsPage
